// import React, { useState, useEffect, useRef } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    useToast,
// } from '@chakra-ui/react';
// import { useDispatch } from 'react-redux';
// import { renderFormControl } from 'utils/DynamicFormData';
// import { getArea, addArea, updateArea } from '../../../../../redux/actions/area';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { useGlobal } from 'contexts';

// // Yup Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
//    ciId: Yup.string().required('City is required'),
// });

// const AreaMasterForm = ({
//    isOpen,
//    onClose,
//    isEditMode = false,
//    demoname,
//    currentRow = null,
//    onSave,
//    saveandcontinue = true,
// }) => {
//    const { cityList, stateList, countryList } = useGlobal();
//    const [row, setRow] = useState({
//       name: '',
//       ciId: '',
//       stateId: '',
//       coId: '',
//    });
//    const [isLoading, setIsLoading] = useState(false);
//    const [errors, setErrors] = useState({});
//    const toast = useToast();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();

//    // Function to clear form data
//    const clearFormData = () => {
//       setRow({
//          name: '',
//          ciId: '',
//          stateId: '',
//          coId: '',
//       });
//       setErrors({});
//    };

//    // Populate form with current row data when in edit mode
//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData();
//       } else if (isEditMode && currentRow) {
//          setRow({
//             name: currentRow.name || '',
//             ciId: currentRow.ciId || '',
//             // These are only for UI, not for submission
//             stateId: currentRow.stateId || '',
//             coId: currentRow.coId || '',
//          });
//       }
//    }, [isEditMode, currentRow]);

//    const validateStep = async () => {
//       try {
//          await validationSchema.validate(row, { abortEarly: false });
//          setErrors({});
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => {
//          const updatedRow = { ...prev, [field]: value };

//          if (field === 'ciId') {
//             const selectedCity = cityList.find((city) => city.id === Number(value));
//             if (selectedCity) {
//                updatedRow.stateId = selectedCity.stId;
//                const selectedState = stateList.find((state) => state.id === selectedCity.stId);
//                if (selectedState) {
//                   updatedRow.coId = selectedState.coId;
//                }
//             }
//          }

//          if (field === 'stateId') {
//             const selectedState = stateList.find((state) => state.id === Number(value));
//             if (selectedState) {
//                updatedRow.coId = selectedState.coId;
//             }
//          }

//          return updatedRow;
//       });

//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    const preparePayload = () => {
//       return {
//          name: row.name,
//          ciId: row.ciId,
//          // Only include id if in edit mode
//          ...(isEditMode && currentRow && currentRow.id ? { id: currentRow.id } : {}),
//       };
//    };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = preparePayload();

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             await dispatch(updateArea(processedData));
//          } else {
//             await dispatch(addArea(processedData));
//          }
//          dispatch(getArea());
//          onClose();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the area.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = preparePayload();

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             await dispatch(updateArea(processedData));
//          } else {
//             await dispatch(addArea(processedData));
//          }
//          dispatch(getArea());
//          clearFormData();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the area.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const handleSubmit = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit();
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue();
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    useEffect(() => {
//       if (demoname && row.name === '') {
//          setRow((prev) => ({ ...prev, name: demoname }));
//       }
//    }, [demoname, row.name]);

//    const nameInputRef = useRef(null);
//    const cityRef = useRef(null);
//    const stateRef = useRef(null);
//    const countryRef = useRef(null);
//    const glGroupRef = useRef(null);

//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100);
//    }, [isOpen]);

//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' ||
//             activeElement?.isContentEditable;

//          if (isTyping) return;

//          if (e.key.toLowerCase() === 's') {
//             if (e.shiftKey) {
//                handlesavecontinue();
//             } else {
//                handleSubmit();
//             }
//          }
//          if (e.key.toLowerCase() === 'c') {
//             onClose();
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === "Escape") {
//             e.preventDefault();
//             onClose();
//          }
//       };

//       document.addEventListener("keydown", handleEsc);
//       return () => {
//          document.removeEventListener("keydown", handleEsc);
//       };
//    }, [onClose]);

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} size="3xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '50%', md: '20%', xl: '15%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
//                {isEditMode ? 'Edit Area' : 'Add New Area'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }} gap={6}>
//                   <GridItem>
//                      {DynamicInput(
//                         'name',
//                         'Name',
//                         {
//                            value: row.name,
//                            onChange: (e) => handleInputChange('name', e.target.value),
//                            ref: nameInputRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  cityRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true,
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'ciId',
//                         'City',
//                         cityList,
//                         {
//                            value: row.ciId,
//                            onChange: (value) => handleInputChange('ciId', value),
//                            ref: cityRef,
//                            nextRef: glGroupRef,
//                         },
//                         errors,
//                         textColor,
//                         true,
//                         'Select City',
//                      )}
//                   </GridItem>
//                   {/* <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'stateId',
//                         'State',
//                         stateList,
//                         {
//                            value: row.stateId,
//                            onChange: (value) => handleInputChange('stateId', value),
//                            isDisabled: Boolean(row.stateId && row.cityId),
//                            ref: stateRef,
//                            nextRef: countryRef,
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select State',
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'coId',
//                         'Country',
//                         countryList,
//                         {
//                            value: row.coId,
//                            onChange: (value) => handleInputChange('coId', value),
//                            isDisabled: !!row.stateId,
//                            ref: countryRef,
//                            nextRef: glGroupRef,
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select Country',
//                      )}
//                   </GridItem> */}
//                </Grid>
//             </ModalBody>
//             <ModalFooter>
//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      Save & Continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}
//                >
//                   Save & Finish
//                </Button>
//                <Button variant="ghost" onClick={onClose} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default AreaMasterForm;

import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   useColorMode,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { renderFormControl } from 'utils/DynamicFormData';
import { getArea, addArea, updateArea } from '../../../../../redux/actions/area';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { useGlobal } from 'contexts';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   ciId: Yup.string().required('City is required'),
});

const AreaMasterForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   onSave,
   saveandcontinue = true,
}) => {
   const { cityList, stateList, countryList } = useGlobal();
   const [row, setRow] = useState({
      name: '',
      ciId: '',
      stateId: '',
      coId: '',
   });
   const [isLoading, setIsLoading] = useState(false);
   const [errors, setErrors] = useState({});
   const toast = useToast();
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   // Tailwind-inspired colors with dark mode support
   const themeColors = {
      // Background colors
      bgPrimary: isDark ? 'bg-gray-900' : 'bg-white',
      bgSecondary: isDark ? 'bg-gray-800' : 'bg-gray-50',
      bgAccent: isDark ? 'bg-blue-900/20' : 'bg-blue-50',

      // Text colors
      textPrimary: isDark ? 'text-white' : 'text-gray-900',
      textSecondary: isDark ? 'text-gray-300' : 'text-gray-600',
      textAccent: isDark ? 'text-blue-300' : 'text-blue-600',

      // Border colors
      borderPrimary: isDark ? 'border-gray-700' : 'border-gray-200',
      borderAccent: isDark ? 'border-blue-500/30' : 'border-blue-200',
      borderFocus: isDark ? 'border-blue-400' : 'border-blue-500',

      // Button colors
      btnPrimary: isDark ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600',
      btnSuccess: isDark ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600',
      btnDanger: isDark ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600',
      btnGhost: isDark ? 'text-gray-300 hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-100',

      // Header colors - Special gradient backgrounds
      headerBg: isDark
         ? 'bg-gradient-to-r from-gray-800 via-blue-900/20 to-gray-800 border-b border-gray-700'
         : 'bg-gradient-to-r from-blue-50 via-white to-blue-50 border-b border-blue-200',
      subHeaderBg: isDark
         ? 'bg-gradient-to-r from-gray-800 via-purple-900/20 to-gray-800'
         : 'bg-gradient-to-r from-purple-50 via-white to-purple-50 border-b border-purple-200',
   };

   // Function to clear form data
   const clearFormData = () => {
      setRow({
         name: '',
         ciId: '',
         stateId: '',
         coId: '',
      });
      setErrors({});
   };

   // Populate form with current row data when in edit mode
   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
      } else if (isEditMode && currentRow) {
         setRow({
            name: currentRow.name || '',
            ciId: currentRow.ciId || '',
            // These are only for UI, not for submission
            stateId: currentRow.stateId || '',
            coId: currentRow.coId || '',
         });
      }
   }, [isEditMode, currentRow]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => {
         const updatedRow = { ...prev, [field]: value };

         if (field === 'ciId') {
            const selectedCity = cityList.find((city) => city.id === Number(value));
            if (selectedCity) {
               updatedRow.stateId = selectedCity.stId;
               const selectedState = stateList.find((state) => state.id === selectedCity.stId);
               if (selectedState) {
                  updatedRow.coId = selectedState.coId;
               }
            }
         }

         if (field === 'stateId') {
            const selectedState = stateList.find((state) => state.id === Number(value));
            if (selectedState) {
               updatedRow.coId = selectedState.coId;
            }
         }

         return updatedRow;
      });

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const preparePayload = () => {
      return {
         name: row.name,
         ciId: row.ciId,
         // Only include id if in edit mode
         ...(isEditMode && currentRow && currentRow.id ? { id: currentRow.id } : {}),
      };
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = preparePayload();

      try {
         if (isEditMode && currentRow && currentRow.id) {
            await dispatch(updateArea(processedData));
         } else {
            await dispatch(addArea(processedData));
         }
         dispatch(getArea());
         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the area.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = preparePayload();

      try {
         if (isEditMode && currentRow && currentRow.id) {
            await dispatch(updateArea(processedData));
         } else {
            await dispatch(addArea(processedData));
         }
         dispatch(getArea());
         clearFormData();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the area.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
   }, [demoname, row.name]);

   const nameInputRef = useRef(null);
   const cityRef = useRef(null);
   const savefinishRef = useRef(null);
   const cancelRef = useRef(null);
   const savecontinueRef = useRef(null);
   const stateRef = useRef(null);
   const countryRef = useRef(null);
   const glGroupRef = useRef(null);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100);
   }, [isOpen]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 's') {
            if (e.shiftKey) {
               handlesavecontinue();
            } else {
               handleSubmit();
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            onClose();
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            onClose();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [onClose]);

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
         <ModalOverlay className="backdrop-blur-sm" />
         <ModalContent
            className={`${themeColors.bgPrimary} rounded-2xl shadow-2xl border ${themeColors.borderPrimary} mx-4 mt-8`}>
            {/* Enhanced Header with Gradient */}
            <ModalHeader
               className={`${themeColors.headerBg} ${themeColors.textPrimary} rounded-t-2xl py-6 px-8 border-b ${themeColors.borderPrimary}`}>
               <div className="flex items-center justify-between">
                  <div>
                     <h2 className={`text-2xl font-bold ${themeColors.textPrimary} mb-1`}>
                        {isEditMode ? 'Edit Area' : 'Add New Area'}
                     </h2>
                     <p className={`text-sm ${themeColors.textSecondary}`}>
                        {isEditMode ? 'Update area information' : 'Create new area with city mapping'}
                     </p>
                  </div>
                  <ModalCloseButton
                     className={`rounded-full p-2 ${isDark ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'
                        }`}
                  />
               </div>
            </ModalHeader>

            <ModalBody className="p-8">
               <div className="space-y-6">
                  <div className={`rounded-lg ${themeColors.bgAccent} p-4 border ${themeColors.borderAccent}`}>
                     <h3 className={`text-lg font-semibold ${themeColors.textPrimary} mb-2`}>Area Details</h3>
                     <p className={`text-sm ${themeColors.textSecondary}`}>
                        Enter basic area information and select the corresponding city
                     </p>
                  </div>

                  <Grid
                     templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }}
                     gap={6}>
                     <GridItem>
                        {DynamicInput(
                           'name',
                           'Area Name',
                           {
                              value: row.name,
                              onChange: (e) => handleInputChange('name', e.target.value),
                              ref: nameInputRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    cityRef.current?.focus();
                                 }
                              },
                              className: `w-full rounded-lg border ${themeColors.borderPrimary} ${themeColors.bgPrimary} ${themeColors.textPrimary} focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 py-3 px-4`,
                           },
                           errors,
                           themeColors.textSecondary,
                           'text',
                           true,
                        )}
                     </GridItem>

                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'ciId',
                           'City',
                           cityList,
                           {
                              value: row.ciId,
                              onChange: (value) => handleInputChange('ciId', value),
                              ref: cityRef,
                              nextRef: glGroupRef,
                              className: `w-full rounded-lg border ${themeColors.borderPrimary} ${themeColors.bgPrimary} ${themeColors.textPrimary} focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200`,
                           },
                           errors,
                           themeColors.textSecondary,
                           true,
                           'Select City',
                        )}
                     </GridItem>
                  </Grid>

                  {/* Location Information Display */}
                  {(row.stateId || row.coId) && (
                     <div
                        className={`rounded-xl border ${themeColors.borderAccent} ${themeColors.bgSecondary} p-6 mt-6`}>
                        <h4 className={`text-md font-semibold ${themeColors.textPrimary} mb-4`}>
                           Location Information
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                           <div>
                              <label className={`text-sm font-medium ${themeColors.textSecondary} block mb-2`}>
                                 State
                              </label>
                              <div
                                 className={`rounded-lg border ${themeColors.borderPrimary} ${themeColors.bgPrimary} px-4 py-3 ${themeColors.textPrimary}`}>
                                 {stateList.find((state) => state.id === Number(row.stateId))?.name || 'Not selected'}
                              </div>
                           </div>
                           <div>
                              <label className={`text-sm font-medium ${themeColors.textSecondary} block mb-2`}>
                                 Country
                              </label>
                              <div
                                 className={`rounded-lg border ${themeColors.borderPrimary} ${themeColors.bgPrimary} px-4 py-3 ${themeColors.textPrimary}`}>
                                 {countryList.find((country) => country.id === Number(row.coId))?.name ||
                                    'Not selected'}
                              </div>
                           </div>
                        </div>
                     </div>
                  )}
               </div>
            </ModalBody>

            {/* Enhanced Footer */}
            <ModalFooter
               className={`relative rounded-b-3xl ${isDark
                  ? 'bg-gradient-to-r from-gray-900/80 to-gray-800/80 border-t border-gray-700'
                  : 'bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200'
                  }`}
               py={6}
               px={8}>
               <div className="flex gap-3">
                  {!isEditMode && saveandcontinue === true && (
                     <Button
                        ref={savecontinueRef}
                        onClick={handlesavecontinue}
                        isLoading={isLoading}
                        disabled={isLoading}
                        className={`group relative overflow-hidden transition-all duration-300 ${isDark
                           ? 'bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-500 hover:to-green-500 border border-emerald-500 shadow-lg shadow-emerald-900/30'
                           : 'bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 border border-emerald-400 shadow-lg shadow-emerald-300/30'
                           } text-white font-semibold`}
                        borderRadius="xl"
                        px={8}
                        py={3}
                        _focus={{ boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.4)' }}
                        _hover={{ transform: 'translateY(-2px)' }}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              savefinishRef.current?.focus();
                           }
                        }}>
                        <span className="relative z-10 flex items-center gap-2">
                           <span>💾</span> Save & Continue
                        </span>
                        <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                     </Button>
                  )}

                  <Button
                     ref={savefinishRef}
                     onClick={handleSubmit}
                     isLoading={isLoading}
                     disabled={isLoading}
                     className={`group relative overflow-hidden transition-all duration-300 ${isDark
                        ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 border border-blue-500 shadow-lg shadow-blue-900/30'
                        : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 border border-blue-400 shadow-lg shadow-blue-300/30'
                        } text-white font-semibold`}
                     borderRadius="xl"
                     px={8}
                     py={3}
                     _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)' }}
                     _hover={{ transform: 'translateY(-2px)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowRight') {
                           e.preventDefault();
                           cancelRef.current?.focus();
                        } else if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           if (!isEditMode) {
                              savecontinueRef.current?.focus();
                           }
                        }
                     }}>
                     <span className="relative z-10 flex items-center gap-2">
                        <span>✓</span> Save & Finish
                     </span>
                     <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                  </Button>

                  <Button
                     ref={cancelRef}
                     variant="ghost"
                     onClick={onClose}
                     className={`transition-all duration-300 ${isDark
                        ? 'text-gray-300 hover:text-white hover:bg-red-600/20 border border-gray-600 hover:border-red-500'
                        : 'text-gray-700 hover:text-gray-900 hover:bg-red-50 border border-gray-300 hover:border-red-300'
                        } font-semibold`}
                     borderRadius="xl"
                     px={8}
                     py={3}
                     _focus={{ boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.4)' }}
                     _hover={{ transform: 'translateY(-2px)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           savefinishRef.current?.focus();
                        }
                     }}>
                     <span className="flex items-center gap-2">
                        <span>✕</span> Cancel
                     </span>
                  </Button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default AreaMasterForm;
